import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import Project from 'models/project/project.model';
import User from 'models/user/user.model';
import { ProjectService } from 'services/project/project.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { UserService } from 'services/user/user.service';
import ProjectPermission from 'models/project-permission/project-permission.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-list-project',
  templateUrl: './user-list-project.component.html',
  styleUrls: ['./user-list-project.component.scss']
})
export class UserListProjectComponent implements OnInit, OnDestroy {
  @Input() instance: Project = new Project();
  public user: User = new User();
  public project: Project = new Project();
  public projectPermission: ProjectPermission = new ProjectPermission();

  public userSubscription: Subscription;
  public permSubscription: Subscription;
  public projectSubscription: Subscription;
  public userList: User[] = [];
  constructor(public projectService: ProjectService,
              public userService: UserService,
              public router: Router,
              public snackBar: MatSnackBar,
    ) { }

  async removeUser(user: User) {
    if (await this.projectService.removeUser(this.instance, user)) {
      this.snackBar.open('Felhasználó törölve.', '', {
        duration: 2000
      });
      this.userList = await this.projectService.userList(this.instance);
    }
  }

  async perms(user: User) {
    this.router.navigate(['/project/permissions'], {queryParams: {project: this.project.id, user: user.username}});
  }

  async ngOnInit() {
    if (this.instance.id) {
      this.userList = await this.projectService.userList(this.instance);
      this.userSubscription = this.userService.getCurrentUser()
        .subscribe(r => this.user = r);
      this.permSubscription = this.projectService.getSelectedPermissions()
        .subscribe(r => this.projectPermission = r);
      this.projectSubscription = this.projectService.getSelectedInstance()
        .subscribe(async r => this.project = r);
    }
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

}
